import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MessageParser from './MessageParser.js';
import supports from '../../../../utils/SupportHelper.js';
import CopyMessageButton from './CopyMessageButton.js';

class FollowUpMessage extends Component {
  /**
   * Message is a follow-up if the header should be skipped.
   **/
  static test(props) {
    return !!props.skipHead;
  }

  /**
   * Render a message but do not display details like user or date.
   **/
  render() {
    const isMeMessage = this.props.user.clientId === this.props.me.clientId;

    return (
      <div
        className={
          isMeMessage
            ? 'eyeson-chat-message chat-message__followup me'
            : 'eyeson-chat-message chat-message__followup'
        }
      >
        {!isMeMessage && (
          <div className="chat-avatar-wrap">
            <span className="eyeson-avatar eyeson-avatar__placeholder"></span>
            {supports.ClipboardAPI && (
              <CopyMessageButton
                content={this.props.content}
                onEvent={this.props.onEvent}
              />
            )}
          </div>
        )}
        <div className="content">
          <MessageParser>{this.props.content}</MessageParser>
        </div>
        {isMeMessage && (
          <div className="chat-avatar-wrap">
            <span className="eyeson-avatar eyeson-avatar__placeholder"></span>
            {supports.ClipboardAPI && (
              <CopyMessageButton
                content={this.props.content}
                onEvent={this.props.onEvent}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

FollowUpMessage.propTypes = {
  me: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
};

export default FollowUpMessage;
